enum RealtimeSubject {
    PRODUCT = 'PRODUCT',
    PRODUCT_PRICE = 'PRODUCT_PRICE',
    PRODUCT_CATEGORY = 'PRODUCT_CATEGORY',
    PRODUCT_COLLECTION = 'PRODUCT_COLLECTION',
    PROMOTION = 'PROMOTION',
    ASSET = 'ASSET',
    COLLECTION = 'COLLECTION',
    SYSTEM = 'SYSTEM',
    PRESENTATION = 'PRESENTATION',
    SLIDE = 'SLIDE',
    SERVER = 'SERVER',
    SYSTEMSCREEN = 'SYSTEMSCREEN',
    CAMPAIGN = 'CAMPAIGN'
}

export default RealtimeSubject